/* ============================================ *
 * Product review form
 * ============================================ */
function productReviewForm() {
    var reviewForm = document.getElementById('review-form')

    if (reviewForm !== null) {
        var form = reviewForm,
            url = form.getAttribute('action'),
            nickField = document.getElementById('nickname_field'),
            reviewField = document.getElementById('review_field')

        form.addEventListener('submit', function (e) {
            var data = new FormData(this),
                proceed = form.getElementsByClassName('proceed'),
                validated = false,
                validated_nick = false,
                validated_review = false,
                nickValue = nickField.value,
                nickLength = nickValue.length,
                reviewTextValue = reviewField.value,
                reviewTextLength = reviewTextValue.length

            if (nickLength < 1) {
                document
                    .getElementById('advice-required-entry-nickname_field')
                    .classList.remove('hidden')
                validated_nick = false
            } else {
                document
                    .getElementById('advice-required-entry-nickname_field')
                    .classList.add('hidden')
                validated_nick = true
            }

            if (reviewTextLength > 800 || reviewTextLength < 5) {
                document
                    .getElementById('advice-validate-text-length-review_field')
                    .classList.remove('hidden')
                validated_review = false
            } else {
                document
                    .getElementById('advice-validate-text-length-review_field')
                    .classList.add('hidden')
                validated_review = true
            }

            validated = validated_nick === true && validated_review === true

            if (validated) {
            
                import(
                    /* webpackChunkName: "bsn-modal" */ 'bootstrap.native/dist/components/modal-native.esm.js'
                ).then((BsnModal) => {
                    var modal = new BsnModal.default('#modal-js'),
                        modalSelector = document.querySelector('#modal-js'),
                        httpRequest = new XMLHttpRequest(),
                        button = document.getElementById('review-form-submit')

                    modalSelector.classList.add('review-star-modal')
                    Array.from(proceed).forEach(function (element) {
                        element.classList.remove('hidden')
                    })

                    button.setAttribute('disabled', 'disabled')

                    function sendReview() {
                        httpRequest.addEventListener(
                            'readystatechange',
                            function () {
                                if (
                                    httpRequest.readyState === XMLHttpRequest.DONE
                                ) {
                                    if (
                                        httpRequest.readyState === 4 &&
                                        httpRequest.status === 200
                                    ) {
                                        modalSelector.querySelector(
                                            '.modal-body'
                                        ).innerHTML =
                                            '<div class="modal-body__content review-modal"><p class="h2">Dziękujemy!</p><p>Twój komentarz został dodany i oczekuje na moderację.</p></div>'
                                        form.reset()
                                        Array.from(document.querySelectorAll('.star-rating__input')).forEach((el) => el.classList.remove('is-checked'));
                                    } else {
                                        modalSelector.querySelector(
                                            '.modal-body'
                                        ).innerHTML =
                                            '<div class="modal-body__content review-modal"><p>Przepraszamy, wystąpił błąd. Proszę spróbować ponownie.</p></div>'
                                    }
                                    Array.from(proceed).forEach(function (element) {
                                        element.classList.add('hidden')
                                    })
                                    button.removeAttribute('disabled')
                                    modal.show()
                                }
                            }
                        )
                        httpRequest.open('POST', url)
                        httpRequest.setRequestHeader(
                            'X-REQUESTED-WITH',
                            'XMLHttpRequest'
                        )
                        httpRequest.send(data)
                    }

                    const ratingChecked = [...document.querySelectorAll(".star-rating__input")].some(c=>c.checked);

                    if (ratingChecked) {
                       sendReview()
                    }
                    else {
                        modalSelector.querySelector(
                            '.modal-body'
                        ).innerHTML =
                            '<div class="modal-body__content review-modal ">'+ 
                            '<p class="review-modal__title"> Czy chcesz dodać gwiazdki dla tego produktu? </p>' +
                            '<div class="review-modal__action">' +
                            '<button class="btn js-no-rating">Nie</button><button class="btn btn--bg js-add-rating">Tak</button>'+
                            ' </div>'
                            ' </div>'
                        modal.show()

                        const noRating = document.querySelector('.js-no-rating')
                        noRating.addEventListener('click', () => {
                            noRating.setAttribute('disabled', 'disabled')
                            sendReview()
                        })

                        const addRating = document.querySelector('.js-add-rating')
                        addRating.addEventListener('click', () => {
                            const reviewModal = document.querySelector('.review-modal__action')
                            reviewModal.classList.add('review-modal__action--stars')
                            const rating = document.getElementById('product-review-table').innerHTML
                            reviewModal.innerHTML = rating
                        })
                        const stars = [...document.querySelectorAll(".star-rating__input")]
                        stars.forEach(star => {
                            star.addEventListener('click', (e) => {
                                const el = e.target.dataset.rating
                                const modalStars = document.querySelectorAll(`[data-rating=` + el +`]`)
                                modalStars.forEach(modalStar => {modalStar.classList.add('is-checked')})
                                const isModalActive = document.querySelector('.review-star-modal').classList.contains('show')
                                if (isModalActive) {
                                    sendReview()
                                }
                            })
                        })
                    }

                    modalSelector.addEventListener('hidden.bs.modal', function () {
                        button.removeAttribute('disabled')
                        Array.from(proceed).forEach(function (element) {
                            element.classList.add('hidden')
                        })
                    }), false
                })

                e.preventDefault()
                return false
            }
        })
    }

    document.documentElement.addEventListener(
        'aoestatic_afterblockreplace',
        () => {
            const isLoggedin = Cookies.get(
                'aoestatic_w1_isloggedin'
            )

            const reviewForm = document.querySelector('.product-reviews__form')
            if (reviewForm) {
                if (isLoggedin === '0') {
                    reviewForm.classList.add('reviews-disabled')
                }
                else {
                    reviewForm.classList.add('reviews-visible')
                }
            }
        }
    )

    if (window.location.href.indexOf('#reviews') > -1) {
       const reviewsSection =  document.querySelector('.product-reviews__form')
       setTimeout(() => {
            reviewsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            })
        }, 50)
    }
}

export { productReviewForm }
